module.exports = __webpack_public_path__ + "img/teaser_traktor6.3dc00913.jpg";